import { Event } from '../Event'
import { Identity } from '../../constants'

export interface CheckoutStepCompletedEventProperties {
  checkout_id: string
  step: number
}

export class CheckoutStepCompletedEvent extends Event<CheckoutStepCompletedEventProperties> {
  static displayName = 'Checkout Step Completed'

  static allowedIdentities = [Identity.Guest, Identity.Consumer]
}
